// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-dependency .form-buttons {
  padding: 10px 5px 5px 0;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}
.manage-dependency .chart-view-btn {
  margin-right: 10px;
  padding: 5px 12px;
}
.manage-dependency .p-dialog-content {
  padding: 0px 30px 30px !important;
}
.manage-dependency .md-dialog-header {
  padding: 0 0 10px 0;
  display: flex;
  justify-content: space-between;
}
.manage-dependency .md-dialog-header .md-header {
  font-size: 16px;
}
.manage-dependency .md-actions {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 5px;
}
.manage-dependency .datascroller-header {
  position: sticky;
  top: 0;
  z-index: 1;
}
.manage-dependency .ds-headers {
  padding: 10px 0 10px 15px;
  background: #fafcff;
  color: #595959;
  font-size: 14px;
  font-weight: bold;
  line-height: 96.023%;
}
.manage-dependency .ds-subheaders {
  padding: 10px 0 20px 15px;
  color: #595959;
  font-size: 12px;
  font-weight: bold;
  line-height: normal;
}
.manage-dependency .jobs {
  padding-bottom: 25px;
}
.manage-dependency .predecessor {
  padding-left: 25px;
}
.manage-dependency .successor-text,
.manage-dependency .predecessor-text,
.manage-dependency .selected-dependency {
  text-wrap: balance;
  overflow-wrap: anywhere;
  padding: 5px;
  width: 100%;
  background-color: rgb(246, 246, 249);
  border: 1px solid rgb(221, 222, 224);
  border-radius: 4px;
}
.manage-dependency .successor-text .dependency-name,
.manage-dependency .predecessor-text .dependency-name,
.manage-dependency .selected-dependency .dependency-name {
  text-wrap: balance;
  overflow-wrap: anywhere;
}
.manage-dependency .predecessor-select {
  max-width: 300%;
  background-color: white;
  border: 1px solid grey;
  border-radius: 4px;
}
.manage-dependency .selected-dependency {
  display: flex;
  justify-content: space-between;
}
.manage-dependency .selected-dependency .sel-dep-del {
  cursor: pointer;
}

.md-multiselect-dropdown {
  max-width: 35%;
}
.md-multiselect-dropdown .p-checkbox {
  display: none;
}
.md-multiselect-dropdown .p-multiselect-close {
  display: none;
}
.md-multiselect-dropdown .p-multiselect-items .p-multiselect-item {
  display: block !important;
  flex-direction: row !important;
  padding: 0px 9px !important;
}
.md-multiselect-dropdown .p-multiselect-header .p-multiselect-filter-container .p-inputtext {
  width: 100%;
}
.md-multiselect-dropdown .p-multiselect-items-wrapper {
  padding: 0px !important;
}
.md-multiselect-dropdown .dependency-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 7px;
  padding-bottom: 7px;
}
.md-multiselect-dropdown .dependency-options .option-name {
  text-wrap: balance;
  overflow-wrap: anywhere;
}
.md-multiselect-dropdown .dropdown-name-color {
  color: black;
  font-weight: bold;
}
.md-multiselect-dropdown .city-name {
  flex: 1 1;
  width: 600px;
}
.md-multiselect-dropdown .add-new-design-intent-icon,
.md-multiselect-dropdown .header-icons {
  margin-left: 10px; /* Add appropriate margin */
  height: 20px;
}
.md-multiselect-dropdown .ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.md-multiselect-dropdown .p-multiselect-panel,
.md-multiselect-dropdown .p-multiselect-items-wrapper > ul > li > span > div {
  white-space: nowrap;
}

.cyclic-error-dialog {
  width: 40%;
  min-height: 30%;
  max-height: 50%;
  border-radius: 20px;
}
.cyclic-error-dialog .p-dialog .p-dialog-header {
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}
.cyclic-error-dialog .p-dialog .p-dialog-header-icons {
  padding-bottom: 5px;
}
.cyclic-error-dialog .p-dialog-md {
  color: red;
}
.cyclic-error-dialog .p-dialog-content {
  padding: 20px 32px 20px 32px !important;
  border-radius: 0 0 20px 20px;
}

.disable-icons {
  opacity: 0.5;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/ManageDependency/index.scss"],"names":[],"mappings":"AACE;EACE,uBAAA;EACA,gCAAA;EACA,+BAAA;AAAJ;AAEE;EACE,kBAAA;EACA,iBAAA;AAAJ;AAEE;EACE,iCAAA;AAAJ;AAEE;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;AAAJ;AACI;EACE,eAAA;AACN;AAEE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AAAJ;AAEE;EACE,gBAAA;EACA,MAAA;EACA,UAAA;AAAJ;AAEE;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAAJ;AAEE;EACE,yBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAAJ;AAEE;EACE,oBAAA;AAAJ;AAEE;EACE,kBAAA;AAAJ;AAEE;;;EAGE,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EAGA,oCAAA;EACA,oCAAA;EACA,kBAAA;AAFJ;AAGI;;;EACE,kBAAA;EACA,uBAAA;AACN;AAEE;EACE,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AAAJ;AAEE;EACE,aAAA;EACA,8BAAA;AAAJ;AACI;EACE,eAAA;AACN;;AAKA;EACE,cAAA;AAFF;AAGE;EACE,aAAA;AADJ;AAIE;EACE,aAAA;AAFJ;AAKE;EACE,yBAAA;EACA,8BAAA;EACA,2BAAA;AAHJ;AAME;EACE,WAAA;AAJJ;AAOE;EACE,uBAAA;AALJ;AAQE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AANJ;AASI;EAEE,kBAAA;EACA,uBAAA;AARN;AAWE;EACE,YAAA;EACA,iBAAA;AATJ;AAYE;EACE,SAAA;EACA,YAAA;AAVJ;AAaE;;EAEE,iBAAA,EAAA,2BAAA;EACA,YAAA;AAXJ;AAaE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAXJ;AAaE;;EAEE,mBAAA;AAXJ;;AAcA;EACE,UAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AAXF;AAYE;EACE,4BAAA;EACA,2BAAA;AAVJ;AAYE;EACE,mBAAA;AAVJ;AAaE;EACE,UAAA;AAXJ;AAaE;EACE,uCAAA;EACA,4BAAA;AAXJ;;AAeA;EACE,YAAA;EACA,oBAAA;AAZF","sourcesContent":[".manage-dependency {\n  .form-buttons {\n    padding: 10px 5px 5px 0;\n    border-bottom-right-radius: 20px;\n    border-bottom-left-radius: 20px;\n  }\n  .chart-view-btn {\n    margin-right: 10px;\n    padding: 5px 12px;\n  }\n  .p-dialog-content {\n    padding: 0px 30px 30px !important;\n  }\n  .md-dialog-header {\n    padding: 0 0 10px 0;\n    display: flex;\n    justify-content: space-between;\n    .md-header {\n      font-size: 16px;\n    }\n  }\n  .md-actions {\n    display: flex;\n    justify-content: flex-end;\n    padding-bottom: 5px;\n  }\n  .datascroller-header {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n  }\n  .ds-headers {\n    padding: 10px 0 10px 15px;\n    background: #fafcff;\n    color: #595959;\n    font-size: 14px;\n    font-weight: bold;\n    line-height: 96.023%;\n  }\n  .ds-subheaders {\n    padding: 10px 0 20px 15px;\n    color: #595959;\n    font-size: 12px;\n    font-weight: bold;\n    line-height: normal;\n  }\n  .jobs {\n    padding-bottom: 25px;\n  }\n  .predecessor {\n    padding-left: 25px;\n  }\n  .successor-text,\n  .predecessor-text,\n  .selected-dependency {\n    text-wrap: balance;\n    overflow-wrap: anywhere;\n    padding: 5px;\n    width: 100%;\n    // background-color: white;\n    // border: 1px solid grey;\n    background-color: rgb(246, 246, 249);\n    border: 1px solid rgb(221, 222, 224);\n    border-radius: 4px;\n    .dependency-name {\n      text-wrap: balance;\n      overflow-wrap: anywhere;\n    }\n  }\n  .predecessor-select {\n    max-width: 300%;\n    background-color: white;\n    border: 1px solid grey;\n    border-radius: 4px;\n  }\n  .selected-dependency {\n    display: flex;\n    justify-content: space-between;\n    .sel-dep-del {\n      cursor: pointer;\n    }\n    // margin-bottom: 5px;\n  }\n}\n\n.md-multiselect-dropdown {\n  max-width: 35%;\n  .p-checkbox {\n    display: none;\n  }\n\n  .p-multiselect-close {\n    display: none;\n  }\n\n  .p-multiselect-items .p-multiselect-item {\n    display: block !important;\n    flex-direction: row !important;\n    padding: 0px 9px !important;\n  }\n\n  .p-multiselect-header .p-multiselect-filter-container .p-inputtext {\n    width: 100%;\n  }\n\n  .p-multiselect-items-wrapper {\n    padding: 0px !important;\n  }\n\n  .dependency-options {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-top: 7px;\n    padding-bottom: 7px;\n    // color: black;\n\n    .option-name {\n      // max-width: 500px;\n      text-wrap: balance;\n      overflow-wrap: anywhere;\n    }\n  }\n  .dropdown-name-color {\n    color: black;\n    font-weight: bold;\n  }\n\n  .city-name {\n    flex: 1;\n    width: 600px;\n  }\n\n  .add-new-design-intent-icon,\n  .header-icons {\n    margin-left: 10px; /* Add appropriate margin */\n    height: 20px;\n  }\n  .ellipsis {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .p-multiselect-panel,\n  .p-multiselect-items-wrapper > ul > li > span > div {\n    white-space: nowrap;\n  }\n}\n.cyclic-error-dialog {\n  width: 40%;\n  min-height: 30%;\n  max-height: 50%;\n  border-radius: 20px;\n  .p-dialog .p-dialog-header {\n    border-top-right-radius: 6px;\n    border-top-left-radius: 6px;\n  }\n  .p-dialog .p-dialog-header-icons {\n    padding-bottom: 5px;\n  }\n\n  .p-dialog-md {\n    color: red;\n  }\n  .p-dialog-content {\n    padding: 20px 32px 20px 32px !important;\n    border-radius: 0 0 20px 20px;\n  }\n}\n\n.disable-icons {\n  opacity: 0.5;\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
